module.exports = __webpack_public_path__ + "img/quard4.919d5128.png";